<script setup>
import { onUnmounted, ref, watch } from 'vue';

const props = defineProps({
  text: { type: String, default: '' },
  /** 每个字符间隔（毫秒） */
  speed: { type: Number, default: 42 },
  /** 是否显示光标 */
  cursor: { type: Boolean, default: true },
});

const displayed = ref('');
const typing = ref(false);
let timer = null;

function clearTimer() {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
}

function startTyping(text) {
  clearTimer();
  displayed.value = '';
  typing.value = true;

  if (!text) {
    typing.value = false;
    return;
  }

  let index = 0;
  timer = setInterval(() => {
    if (index < text.length) {
      displayed.value += text[index];
      index += 1;
      return;
    }
    clearTimer();
    typing.value = false;
  }, props.speed);
}

watch(
  () => props.text,
  (value) => startTyping(value ?? ''),
  { immediate: true },
);

onUnmounted(clearTimer);
</script>

<template>
  <span class="typewriter-text">
    {{ displayed }}<span v-if="cursor && typing" class="typewriter-cursor">|</span>
  </span>
</template>

<style scoped>
.typewriter-cursor {
  margin-left: 1px;
  font-weight: 300;
  opacity: 0.55;
  animation: typewriter-blink 0.9s step-end infinite;
}

@keyframes typewriter-blink {
  50% {
    opacity: 0;
  }
}
</style>
